import React, {useEffect,useState} from 'react'
import BurpsuiteEnterpriseMappingForm from './BurpsuiteEnterpriseMappingForm';
import BurpsuiteEnterpriseCredentialsForm from './BurpsuiteEnterpriseCredentialsForm';
import GenericPullConfigListing from '../GenericPullConfigListing';

export default function BurpsuiteEnterpriseConfigListing(props) {

    const [loginConfig,setLoginConfig] = useState([]);

    useEffect(()=>{
        if(props.loginConfigList && props.loginConfigList.length){
            let value = props.loginConfigList.map((login)=> {
                const {username, ...restConfig} = login;
                return { 
                   ...restConfig,
                   accessKey: username
                }
            })
        setLoginConfig(value);
        } else {
            setLoginConfig([])
        }
    },[props.loginConfigList])


    return (
        <GenericPullConfigListing
            {...props}
            loginConfigList={loginConfig}
            toolName={props.name}
            MappingForm={BurpsuiteEnterpriseMappingForm}
            CredentialsForm={BurpsuiteEnterpriseCredentialsForm}
            componentName="Site Name"
            componentKey="name"
        />
    )
}